export default __webpack_public_path__ + "static/media/gallery_11.7d0b96d2.jpeg";